<template>
  <!-- 成单喜报的分享页面   -->
  <div class="wrap">
    <div class="is-weiXin-tip hidden" :class="{'show':isWx}">
      <img class="tip-open" src="@/assets/case-share-detail/what_tip.png" alt="">
    </div>
    <img class="banner" src="@/assets/imgs/share-page/Frame1321315956@2x.png">
    <!--  头部信息  -->
    <div class="header-box flex flex-space-between">
        <div class="texts pr">
          <p>点击红包沾喜气</p>
          <p >瓜分20个现金红包<img src="@/assets/imgs/share-page/Frame1321315959@2x.png"> </p>
          <img class="icon" src="@/assets/imgs/share-page/money-bg.png">
        </div>
        <img class="red-bag block" src="@/assets/imgs/share-page/Frame8670@2x.png">
    </div>
    <!-- 滚动通知   -->
    <div v-if="scrollLists.length >0" class="swipe-box">
      <van-notice-bar  :scrollable="false">
        <van-swipe
            vertical
            class="notice-swipe"
            :autoplay="3000"
            :show-indicators="false"
        >
          <van-swipe-item class="flex flex-align-center" v-for="(item,i) in scrollLists" :key="i">
            <img class="header-icon" v-if="item.avatar" :src="item.avatar">
            <span class="line1 block">刚刚{{item.lawyerName}}律师通过沾沾喜气，获得{{priceYuan(item.amount,1)}}个法临币</span>
          </van-swipe-item>
        </van-swipe>
      </van-notice-bar>
    </div>
    <div class="content-wrap">
      <img class="banner1" src="@/assets/imgs/share-page/Frame1321314799@2x.png">
      <h4>{{ detail.title }}</h4>
      <div class="desc-date">{{ detail.createTime }} <a>#{{ detail.typeLabel }}</a> {{ detail.totalPv }}浏览</div>
      <div class="line"></div>
      <div class="con-box">
        <div class="box-tit"><i></i> 成案律师</div>
        <div class="box-lawyer flex-space-between flex flex-align-center">
          <div class="lawyer-info flex">
            <div class="lawyer-img">
              <img class="lawyer-info-header" :src="detail.lawyerAvatar">
              <img v-if="detail.isVip" class="lawyer-info-icon" src="@/assets/imgs/share-page/icon-v.png">
            </div>
            <div>
              <h5>{{ detail.lawyerName }} <i>{{ detail.lawyerCity }}</i></h5>
              <p class="lawyer-info-tag font11">
                <i>擅长{{ detail.lawyerWorkFieldList[0] }}</i>
                <i>官方认证</i>
              </p>
            </div>
          </div>
          <div class="box-case tc">
            <p>案源消耗数</p>
            <p><a>{{ detail.serverCaseNumCount }}</a> 次</p>
          </div>
        </div>
      </div>
      <div class="con-box pr">
        <div class="box-tit"><i></i> 案件信息</div>
        <img class="pa icons" src="@/assets/imgs/share-page/ca.png">
        <ul>
          <li v-for="(item,i) in lists" :key="i" class="flex flex-align-center flex-space-between">
            <label>{{ item.label }}</label>
            <i>{{  item.type === 'money' ? priceYuan(detail[item.prop]) : detail[item.prop] }}</i>
          </li>
        </ul>
      </div>
      <div class="con-box">
        <div class="box-tit"><i></i> 案件回顾</div>
        <div>{{ detail.caseReview }}</div>
      </div>
      <div class="con-box">
        <div class="box-tit"><i></i> 案件详情</div>
        <div>{{ detail.caseDetail }}</div>
      </div>
      <div class="con-desc">
        本文版权归原作者所有，内容仅代表作者本人观点，不代表法临平台的立场。如有任何疑问或需要删除请通过
        <a>【客服中心】</a>联系我们。
      </div>
    </div>
    <div class="footers">
      <button  @click="handleOpen">点击前往APP沾沾喜气，瓜分现金红包</button>
      <p>已有<i>{{ detail.redPacketGetNum || 0 }}人</i>沾他喜气，还剩<i>{{ detail.redPacketRemainNum }}个</i>现金红包 </p>
<!--      <a @click="buttonDownload">立即下载</a>-->
    </div>
    <!--  红包弹窗  -->
    <popupIndex class="popup-wrap" :show.sync="dialog">
      <div class="red-box" @click.stop="handleOpen">
        <div class="header-ataver"> <img :src="detail.lawyerAvatar">沾沾{{detail.lawyerName}}律师成单喜气 </div>
        <h1>最高瓜分<i>100</i>个法临币</h1>
        <p>看看您的运气吧</p>
        <div class="red-box-text">· 已有<i>{{ detail.redPacketGetNum || 0 }}人</i>沾他喜气，还剩<i>{{ detail.redPacketRemainNum}}个</i>现金红包 ·</div>
      </div>
    </popupIndex>

  </div>
</template>

<script>
import goApp from "@/mixins/goApp";
import {priceYuan} from "../../libs/tool";
import {redPacketMoment ,getShareGoodNewsShareDetail} from "@a/case-share-detail";
import {NoticeBar, Swipe, SwipeItem} from "vant";
import PopupIndex from "@c/layout/popup/index.vue";

export default {
  name: "goodNews",
  data() {
    return {
      lists: [
        {
          label: '成案线索类型',
          prop: 'type'
        }, {
          label: '案件类型',
          prop: 'typeLabel'
        }, {
          label: '成案地点',
          prop: 'regionName'
        }, {
          label: '成案周期',
          prop: 'caseSuccessDay'
        }, {
          label: '涉案金额',
          prop: 'amount'
        }, {
          label: '成案委托金额',
          type:'money',
          prop: 'caseEntrustAmount'
        },
        // {
        //   label: '抢案权益类型',
        //   prop: 'caseRightType'
        // },
      ],
      detail: {
        lawyerWorkFieldList:[]
      },
      scrollLists:[ ],
      dialog:false,
      isWx:false,
      timer:null
    }
  },
  mixins: [goApp],
  mounted() {
    getShareGoodNewsShareDetail({id: this.$route.query?.id}).then(r => {
      this.detail = r.data || {}
      localStorage.setItem('GOODNEWSLAWYERID',this.detail?.lawyerId)
      this.dialog = true
    })

    redPacketMoment().then(({data})=>{
      this.scrollLists = data || []
    })
  },
  methods:{
    priceYuan,
    handleOpen(){
      this.isWx = this.is_weixn()
      if(!this.is_weixn()){
        this.openApp()
      this.timer =  setTimeout(()=>{
          this.buttonDownload()
        },2500)
      }

    }
  },
  beforeDestroy() {
    if(this.timer){
      clearTimeout(this.timer)
    }
  },
  components: {
    PopupIndex,
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem,
    'van-notice-bar': NoticeBar,
  },
}
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
}

.wrap {
  padding-bottom: 130px;
}

.is-weiXin-tip {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999999999;
  text-align: right;

  .tip-open {
    width: 5.08rem;
    height: 3.52rem;
    position: fixed;
    z-index: 99;
    top: 0;
    right: 0.12rem;
  }
}

.content-wrap {
  padding: 20px 16px;
  border-radius: 16px 16px 0px 0px;
  background-color: #FFFFFF;
  position: relative;
  top: -20px;

  i {
    font-style: normal;
  }

  .banner1 {
    width: 250.47px;
    height: 23px;
  }

  h4 {
    color: #333333;
    margin: 16px auto;
    line-height: 21px;
    font-size: 18px;
  }

  .desc-date {
    font-weight: 400;
    color: #999999;
    font-size: 12px;

    a {
      color: #3887F5;
      margin: 0 9px;
    }
  }

  .line {
    border-top: 1px dotted #F5F5F5;
    margin: 16px auto;
  }

  .con-box {
    margin-bottom: 32px;

    .box-tit {
      padding-bottom: 10px;

      i {
        display: inline-block;
        width: 3px;
        height: 18px;
        background: #3887F5;
        margin-right: 6px;
        vertical-align: bottom;
      }

      font-size: 16px;
      font-weight: 500;
      color: #111111;
    }

    .box-lawyer {
      background: #F5F5F7;
      border-radius: 8px 8px 8px 8px;
      padding: 12px;
      margin-bottom: 28px;

      .lawyer-img {
        width: 40px;
        height: 40px;
        position: relative;
        margin-right: 8px;
      }

      .lawyer-info-header {
        width: 40px;
        height: 40px;
      }

      .lawyer-info-icon {
        width: 12px;
        height: 12px;
        position: absolute;
        right: 0;
        bottom: 0;
      }

      h5 {
        color: #333333;
        font-size: 16px;

        i {
          color: #999999;
          font-size: 12px;
          font-weight: 400;
        }
      }

      .lawyer-info-tag {
        margin-top: 7px;

        i {
          padding: 1px 4px;
          background: #FFF8EC;
          border-radius: 3px 3px 3px 3px;
          opacity: 1;
          border: 1px solid rgba(189, 147, 76, 0.3);
          font-weight: 400;
          color: #BD934C;
          margin-right: 4px;
        }
      }

      .box-case {
        font-size: 12px;
        color: #3887F5;
        line-height: 20px;

        a {
          font-size: 16px;
        }
      }
    }
  }
}

ul {
  li {
    padding: 8px 0;
    color: #666666;

    i {
      color: #333333;
    }
  }
}

.icons {
  width: 88px;
  height: 88px;
  top: 55px;
  right: 72px;
}

.footers {
  height: 111px;
  background: #FFFFFF;
  background: linear-gradient( 180deg, #FDECDF 0%, #FFFFFF 100%);
  border-radius: 8px 8px 0px 0px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;

  button {
    width: 343px;
    height: 60px;
    //line-height: 6px;
    background: url("~@/assets/imgs/share-page/Frame8701@2x.png") no-repeat;
    background-size: 100%;
    //border-radius: 68px 68px 68px 68px;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF;
    border: none;
    margin: 8px auto 8px;
  }

  p {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #865C2D;
    //margin-top: 12px;

    i{
      color: #E51D1E;
      font-style: normal;
    }

    a {
      color: #3887F5;
    }
  }
}

.con-desc {
  color: #999999;
  font-size: 12px;
  padding: 8px;
  background: #F5F5F7;
  border-radius: 4px 4px 4px 4px;

  //a {
  //  color: #3887F5;
  //}
}

.header-box{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  .texts{
    margin-top: 25px;
    margin-left: 17px;

    img{
      width: 40px;
      vertical-align: middle;
    }

    .icon{
      width: 88px !important;
      position: absolute;
      left: 13px;
      bottom: 5px;
      opacity: 0.5;
    }
  }

  p{
    font-weight: 600;
    font-size: 20px;
    color: #E7455B;
    line-height: 23px;
    letter-spacing: 2px;
    text-shadow: 0px 2px 2px #FDBBA2;
    margin-bottom: 4px;
    z-index: 2;
  }

  .red-bag{
    width: 130px;
    height: 84px;
    margin-top: 8px;
  }
}
.swipe-box{
  position: fixed;
  top: 80px;
  left: 12px;
  z-index: 10;
  width: 300px;
  background: rgba(0,0,0,0.6);
  border-radius: 49px 49px 49px 49px;
  ::v-deep .van-notice-bar{
    background: transparent;
    height: 24px;
    padding: 0 2px;
  }
}
.notice-swipe {
  font-weight: 400;
  font-size: 11px;
  color: #FFFFFF;
  height: 24px;
  line-height: 24px;
  padding-left: 2px;
  .header-icon{
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #2676E4;
    vertical-align: middle;
    margin-right: 5px;
  }
}
.red-box{
  width: 296px;
  height: 360px;
  background: url("~@/assets/imgs/share-page/Frame8731@2x.png") no-repeat;
  background-size: 100%;
  padding: 24px 0;
  box-sizing: border-box;
  position: relative;

  .header-ataver{
    font-weight: 400;
    font-size: 18px;
    color: #F9FBE8;
    line-height: 24px;
    text-shadow: 0px 0px 6px rgba(229,47,76,0.6);
    img{
      width: 40px;
      height: 40px;
      background: #D9D9D9;
      border-radius: 50%;
      vertical-align: middle;
      margin-right: 3px;
    }
  }

  h1{
    font-weight: 500;
    font-size: 24px;
    color: #F5E6BC;
    text-shadow: 0px 0px 6px rgba(229,47,76,0.6);
    font-style: normal;
    text-transform: none;
    margin-top: 18px;
    margin-bottom: 8px;
    i{
      font-style: normal;
      font-size: 32px;
    }
  }

  p{
    width: 107px;
    height: 26px;
    background: linear-gradient( 90deg, #FFF2CE 0%, #F6C79A 100%);
    font-weight: 400;
    font-size: 13px;
    color: #E84846;
    border-radius: 0 26px 26px 26px;
    line-height: 26px;
    position: absolute;
    right: 24px;
    //float: right;
  }
  &-text{
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    position: absolute;
    bottom: 24px;
    left: 0;
    right: 0;
    margin: auto;


    i{
      color: #FFF3BF;
      font-style: normal;
    }
  }
}
::v-deep .content{
  background: transparent !important;
  overflow: auto !important;
  max-width: none !important;
}
::v-deep .close-img{
  position: absolute;
  top: -60px;
  right: 0;
}
.popup-wrap{
  overflow-y: initial !important;
}
</style>
